'use client'

import type { NavigationFoldoutToggleButtonProps } from '@maestro/commerce-blocks/components/navigation-header/navigation-foldout.types'

import classNames from 'classnames'
import { useTranslations } from 'next-intl'

import { HeaderControl } from '@maestro/commerce-blocks/components/header-controls'
import { useMobileNavigation } from '@maestro/commerce-blocks/providers/mobile-navigation/context'

export default function NavigationFoldoutToggleButton(
  props: NavigationFoldoutToggleButtonProps
) {
  const { customClassName } = props
  const { openMenu } = useMobileNavigation()
  const t = useTranslations('commerce-blocks')

  return (
    <HeaderControl
      icon="menu"
      title={t('navigation-header.menu-trigger')}
      ariaLabel={t('navigation-header.open-menu')}
      onClick={openMenu}
      customClassName={classNames(
        'header-control--menu desktop-only',
        customClassName
      )}
    />
  )
}
